import { render, staticRenderFns } from "./DeclarationCotisationOldPage.vue?vue&type=template&id=4ec80361&scoped=true&"
import script from "./DeclarationCotisationOldPage.vue?vue&type=script&lang=js&"
export * from "./DeclarationCotisationOldPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec80361",
  null
  
)

export default component.exports